<div class="d-flex flex-column align-items-center">
  <div *ngIf="loading">
    <mat-spinner diameter="150" mode="indeterminate"></mat-spinner>
  </div>
  <div *ngIf="!loading" class="main-part">

    <div *ngIf="status=='preparing'" class="d-flex flex-column align-items-center preparing-part">
      <h2>Download in progress</h2>
      <app-loader [label]="'Preparing files (' + preperingProgress + '%)'" loaderType="file-packing"></app-loader>
    </div>

    <div *ngIf="status=='downloading'" class="d-flex flex-column align-items-center download-part">
      <h2>Download in progress</h2>
      <app-status-radial-bar [progressValue]="processingProgress | uploadingFileStatusToNumber" [nameLabel]="downloadLabel" statusLabel=""
                                           [insideLabel]="processingProgress | uploadingFileStatusToNumber | number: '1.0-0'" status="Downloading">
      </app-status-radial-bar>
    </div>

    <div *ngIf="status=='bad_token'" class="d-flex flex-column align-items-center">
      <h2>Wrong entry!</h2>
      <span class="normal-text">There is nothing here</span>
      <a class="share-medix-btn" href="https://sharemedix.com/contact/">Start using ShareMedix</a>
    </div>

    <div *ngIf="status=='error'" class="d-flex flex-column align-items-center">
      <h2>Something went wrong!</h2>
      <span class="normal-text">Try again!</span>
      <a class="share-medix-btn" (click)="reload()">Refresh</a>
    </div>

    <div *ngIf="status=='expired'" class="d-flex flex-column align-items-center expired-part">
      <h2>Empty!</h2>
      <span class="normal-text">File expired or your link is inactive.</span>
      <a class="share-medix-btn" href="https://sharemedix.com/contact/">Start using ShareMedix</a>
    </div>

    <div *ngIf="status=='password'" class="d-flex flex-column password-part">
      <h2 @loginItem>Please provide password:</h2>
      <form (submit)="submitPassword()" class="form-inline p-0" [formGroup]="passwordForm" >
        <app-alert [message]="message" [type]="messageType" @loginItem></app-alert>
        <div class="login-input-container" @loginItem>
          <label class="sr-only" for="file_password">Password</label>
          <div class="input-group">
            <div class="input-group-prepend">
              <div class="input-group-text"><img src="./assets/ui/svg/grey/icon-password.svg"/></div>
            </div>
            <div class="vertical-divider"></div>
            <input type="password" id="file_password" name="file_password" placeholder="Password" #filePasswordInput formControlName="file_password" autofocus>
          </div>
        </div>
        <button @loginItem type="submit" [class]="loading || !passwordForm.valid ? 'non-active' : 'active'" [disabled]="loading || !passwordForm.valid">Download</button>
      </form>
    </div>

    <div *ngIf="status=='done'" class="d-flex flex-column align-items-center done-part">
      <h2>Done!</h2>
      <span class="normal-text">Your files have been downloaded.</span>
      <img src="./assets/ui/svg/green/icon-check-correct-animated.svg">
      <span class="bigger-text text-center" >Anonymize and share <br>your data.</span>
      <a class="share-medix-btn" href="https://sharemedix.com/contact/">Start using ShareMedix</a>
    </div>

  </div>

</div>
